import { render, staticRenderFns } from "./PayrollConceptsView.vue?vue&type=template&id=196b5774"
import script from "./PayrollConceptsView.vue?vue&type=script&lang=js"
export * from "./PayrollConceptsView.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports